import { render, staticRenderFns } from "./assessCourse.vue?vue&type=template&id=1555b3ab&scoped=true&"
import script from "./assessCourse.vue?vue&type=script&lang=js&"
export * from "./assessCourse.vue?vue&type=script&lang=js&"
import style0 from "./assessCourse.vue?vue&type=style&index=0&id=1555b3ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1555b3ab",
  null
  
)

export default component.exports